export default "__VITE_ASSET__Bg$Ni7VG__"